var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tag === 'header')?_c('header',[_vm._t("default")],2):(_vm.tag === 'footer')?_c('footer',[_vm._t("default")],2):(_vm.tag === 'section')?_c('section',[_vm._t("default")],2):_c('div',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }